//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapActions } from "vuex";
import { APP_DATE_DOT_FORMAT } from "@/assets/js/appConfig";
import {
    convertAndFormatTimeToLocal,
    copyToClipboard
} from "@/assets/js/appFunc";
import { formatDateAndTime } from "@/components/Diagrams/config/set-conditions";
import AQCard from "@/components/Generics/AQCard/AQCard.vue";
import AQButton from "@/components/Generics/AQButton/AQButton.vue";
import AQDialog from "@/components/Generics/AQDialog/AQDialog.vue";
import AQTooltip from "@/components/Generics/AQTooltip/AQTooltip.vue";
import AQInput from "@/components/Generics/AQInput/AQInput.vue";
import AQBadge from "@/components/Generics/AQBadge/AQBadge.vue";
import AQListBtn from "@/components/Generics/AQButtonsList/AQButtonsList.vue";
import PIModalErrorInfo from "./components/PIModalErrorInfo.vue";
import PIChangeRetentionModal from "./PIChangeRetentionModal.vue";

const defaultImage = require("@/assets/images/appDefault.svg");

const timeUnitMappings = { D: "apps.days", W: "apps.weeks", M: "apps.months", Y: "apps.years" };

export default {
    components: {
        PIModalErrorInfo,
        AQCard,
        AQButton,
        AQDialog,
        AQTooltip,
        AQInput,
        AQBadge,
        AQListBtn,
        PIChangeRetentionModal
    },
    props: {
        mode: {
            type: String,
            default: "a", // a -single application summary, b - multiple applications
            validator: v => ["a", "b"].includes(v.toLowerCase())
        },
        instanceID: {
            type: String,
            default: ""
        },
        selectedInstances: {
            type: Array,
            default: () => []
        },
        isAchiveDisabled: {
            type: Boolean,
            default: false
        },
        isTerminateDisabled: {
            type: Boolean,
            default: false
        },
        isRetryDisabled: {
            type: Boolean,
            default: false
        },
        isArchiving: {
            type: Boolean,
            default: false
        },
        isArchived: {
            type: Boolean,
            default: false
        },
        applicationName: {
            type: String,
            default: ""
        },
        processDefId: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
            defaultAppImg: defaultImage,
            nrOfInstancesAndApps: null,
            payloadProcessDefIds: [],
            needsRefreshTable: false,
            filtredInstances: {},
            open: false,
            systemStatus: "RUNNING",
            splitInstancesPerAppObj: {},
            processInspectorDescriptionById: {},
            kibanaViewLogs: [],
            showViewLogs: false,
            loading: false,
            confirmLabel: "",
            retentionModal: false,
            period: 6,
            timeUnit: "M",
            deletionDateProp: "",
            wrongPattern: false,
            retentionProp: "",
            deletionInput: "",
            retentionInput: "",
            buttonsArray: [
                {
                    name: this.$t("admin.processInspector.retry"),
                    type: "Retry",
                    id: "retry-btn-modal",
                    isDisabled: false,
                    action: this.retryInstanceModal
                },
                {
                    name: this.$t("admin.processInspector.terminateConfirm"),
                    type: "Terminate",
                    id: "terminate-btn-modal",
                    isDisabled: false,
                    action: this.teminateInstanceModal
                },
                {
                    name: this.$t("admin.processInspector.viewLogs"),
                    type: "ViewLogs",
                    id: "view-logs-btn-modal",
                    isDisabled: false,
                    action: this.viewLogs
                },
                {
                    name: this.$t("admin.processInspector.downloadLog"),
                    type: "DownloadLog",
                    id: "download-log-btn-modal",
                    isDisabled: false,
                    action: this.downLoadLogs
                },
                {
                    name: this.$t("admin.processInspector.archive"),
                    type: "Archive",
                    id: "archive-btn-modal",
                    isDisabled: false,
                    action: this.archiveInstanceModal
                }
                // {
                //     name: this.$t("admin.processInspector.deleteBtn"),
                //     type: "Delete",
                //     id: "delete-btn-modal",
                //     isDisabled: false,
                //     action: this.deleteInstanceModal
                // }
            ],
            openDialog: false,
            titleDialog: "",
            messageTitle: "",
            payloadInstace: {},
            deleteInstance: false,
            disabledName: true,
            initialInstanceName: "",
            hideListBtns: ["edit", "more", "delete", "download"]
        };
    },
    computed: {
        ...mapGetters("admin", ["getProcessInspectorById", "featuresByTenant"]),
        ...mapGetters("main", ["getCurrentProcessDefinition"]),
        buttonName() {
            return this.disabledName ? this.$t("admin.processInspector.change") : this.$t("admin.processInspector.cancel");
        },
        indefiniteProp() {
            return (this.isRetention && !this.retentionProp) || (!this.isRetention && !this.deletionDateProp);
        },
        applicationDetailsPI() {
            return `${this.processInspectorDescriptionById.applicationName} ${this.$t("admin.processInspector.publishedBy")
            } ${this.processInspectorDescriptionById.publisher} ${this.$t("admin.processInspector.on")} ${this.publishDate}`;
        },
        processDetailsPI() {
            return `${this.processInspectorDescriptionById.processDefinitionName} ${this.$t("admin.processInspector.publishedBy")
            } ${this.processInspectorDescriptionById.publisher} ${this.$t("admin.processInspector.on")} ${this.publishDate}`;
        },
        errorInfoProps() {
            return {
                mode: "sum",
                processInspectorDescriptionById: this
                    .processInspectorDescriptionById,
                isArchiving: this.isArchiving
            };
        },
        startDate() {
            return this.convertAndFormatTimeToLocal(
                this.processInspectorDescriptionById.startDate,
                APP_DATE_DOT_FORMAT
            );
        },
        viewLogsDisplayed() {
            let display = false;
            const feature = this.featuresByTenant.find(
                element => element.code === "KIBANA_LOG"
            );
            if (feature) {
                display = feature.enabled;
            }
            return display;
        },
        getNrOfInstancesAndApps() {
            const nrOfFiltredInstances = Object.keys(this.filtredInstances)
                .length;
            const nrOfInstancesAndApps = this.selectedInstances.length
                    + this.$t(
                        "admin.processInspector.appSummary.headerInstanceFrom"
                    )
                    + nrOfFiltredInstances
                    + (nrOfFiltredInstances > 1
                        ? this.$t(
                            "admin.processInspector.appSummary.headerAppsSelected"
                        )
                        : this.$t(
                            "admin.processInspector.appSummary.headerAppSelected"
                        ));
            this.$emit("nrOfInstancesPerApps", this.splitInstancesPerAppObj);
            this.$emit("nrOfInstancesAndApps", nrOfInstancesAndApps);
            return nrOfInstancesAndApps;
        },
        lastUpdate() {
            return this.convertAndFormatTimeToLocal(
                this.processInspectorDescriptionById.lastUpdate,
                APP_DATE_DOT_FORMAT
            );
        },
        publishDate() {
            return this.convertAndFormatTimeToLocal(
                this.processInspectorDescriptionById.publishDate,
                APP_DATE_DOT_FORMAT
            );
        },
        filteredButtons() {
            return this.buttonsArray.filter(item => {
                let filter = false;
                const { systemStatus } = this.processInspectorDescriptionById;
                if (!this.isArchived) {
                    if (item.type === "Retry") {
                        if (!this.isArchiving && systemStatus === "Failed") {
                            filter = true;
                        }
                    } else if (item.type === "Terminate") {
                        if ((systemStatus === "Running" || systemStatus === "Failed") && !this.isArchiving && !this.isChildSync) {
                            filter = true;
                        }
                    } else if (item.type === "ViewLogs") {
                        if ((systemStatus === "Running" || systemStatus === "Failed" || !this.isArchived) && !this.isArchiving && this.viewLogsDisplayed) {
                            filter = true;
                        }
                    } else if (item.type === "DownloadLog") {
                        if ((systemStatus === "Running" || systemStatus === "Failed"
                        || systemStatus === "Suspended" || !this.isArchived) && !this.isArchiving) {
                            filter = true;
                        }
                    } else if (item.type === "Archive") {
                        if (systemStatus !== "Running" && systemStatus !== "Failed" && !this.isArchiving && !this.isArchived && !this.isChildSync) {
                            filter = true;
                        }
                    } else if (item.type === "Delete") {
                        if ((systemStatus === "Completed" || systemStatus === "Terminated") && !this.isChildSync) {
                            filter = true;
                        }
                    }
                } else if (item.type === "Delete" && !this.isChildSync) {
                    filter = true;
                }

                return filter;
            });
        },
        getStatus() {
            return this.isArchived ? "ARCHIVED" : this.systemStatus;
        },
        isChildSync() {
            return this.processInspectorDescriptionById.rootProcessInstanceId !== this.processInspectorDescriptionById.processInstanceId;
        },
        isRetention() {
            return ["Running", "Failed"].includes(this.processInspectorDescriptionById.systemStatus);
        },
        retentionLabel() {
            return this.processInspectorDescriptionById.customRetention
                ? `${this.$t("admin.processInspector.retentionPeriod")} ${this.$t("admin.processInspector.custom")}`
                : this.$t("admin.processInspector.retentionPeriod");
        },
        deletionLabel() {
            return this.processInspectorDescriptionById.customRetention
                ? `${this.$t("admin.processInspector.deletionDate")} ${this.$t("admin.processInspector.custom")}`
                : this.$t("admin.processInspector.deletionDate");
        }
    },
    watch: {
        isRetryDisabled: {
            handler(newValue) {
                this.buttonsArray[0].isDisabled = newValue;
            }
        },
        isTerminateDisabled: {
            handler(newValue) {
                this.buttonsArray[1].isDisabled = newValue;
            }
        },
        isAchiveDisabled: {
            handler(newValue) {
                this.buttonsArray[4].isDisabled = newValue;
            }
        },
        selectedInstances: {
            handler(value) {
                if (value && value.length > 1) {
                    value.forEach(instance => {
                        this.payloadProcessDefIds.push(instance.processDefId);
                        if (
                            !this.filtredInstances.hasOwnProperty(
                                instance.applicationName
                            )
                        ) {
                            this.filtredInstances[instance.applicationName] = {
                                imageUrl: instance.imgUrl,
                                all:
                                    instance.systemStatus !== "RUNNING" ? 1 : 0,
                                completed:
                                    instance.systemStatus === "COMPLETED"
                                        ? 1
                                        : 0,
                                terminate:
                                    instance.systemStatus === "TERMINATED"
                                        ? 1
                                        : 0,
                                failed:
                                    instance.systemStatus === "FAILED" ? 1 : 0
                            };
                        } else if (
                            this.filtredInstances.hasOwnProperty(
                                instance.applicationName
                            )
                        ) {
                            if (instance.systemStatus !== "RUNNING") {
                                this.filtredInstances[instance.applicationName]
                                    .all++;
                            }
                            if (instance.systemStatus === "COMPLETED") {
                                this.filtredInstances[instance.applicationName]
                                    .completed++;
                            }
                            if (instance.systemStatus === "TERMINATED") {
                                this.filtredInstances[instance.applicationName]
                                    .terminate++;
                            }
                            if (instance.systemStatus === "FAILED") {
                                this.filtredInstances[instance.applicationName]
                                    .failed++;
                            }
                        }
                        this.splitInstancesPerAppObj[
                            instance.processDefId
                        ] = this.filtredInstances[instance.applicationName].all;
                    });
                }
            },
            immediate: true
        },
        getProcessInspectorById: {
            handler(newValue) {
                if (
                    newValue.constructor === Object
                    && Object.keys(newValue).length
                ) {
                    this.processInspectorDescriptionById = newValue;
                    let timeUnitTranslate = "";
                    if (this.processInspectorDescriptionById.retention) {
                        const transformData = this.processInspectorDescriptionById.retention.slice(1);
                        this.timeUnit = transformData.slice(-1);
                        this.period = parseInt(transformData.slice(0, transformData.length - 1), 10);
                        timeUnitTranslate = this.$t(timeUnitMappings[this.timeUnit]).toLowerCase();
                    }
                    this.deletionDateProp = this.processInspectorDescriptionById.deletionDate;
                    this.retentionProp = this.processInspectorDescriptionById.retention;
                    this.retentionInput = (this.period || this.period === 0) && this.retentionProp
                        ? `${this.period} ${timeUnitTranslate}` : this.$t("apps.indefinite");
                    this.deletionInput = formatDateAndTime("datetime", this.deletionDateProp, true) || this.$t("admin.processInspector.never");
                    this.systemStatus = newValue.systemStatus.toUpperCase();
                }
            },
            immediate: true
        }
    },
    created() {
        this.$root.$on("savedRetention", data => {
            const timeUnitTranslate = this.$t(timeUnitMappings[data.unit]).toLowerCase();
            if (data.period) {
                this.timeUnit = data.unit;
                this.period = parseInt(data.period, 10);
            } else {
                this.timeUnit = "M";
                this.period = 6;
            }
            if (data.type === "INDEFINITE") {
                this.retentionProp = null;
                this.retentionInput = this.$t("apps.indefinite");
            } else {
                this.retentionProp = `P${data.period}${this.timeUnit}`;
                this.retentionInput = `${data.period} ${timeUnitTranslate}`;
            }
        });
        this.$root.$on("savedDeletion", data => {
            if (data.type === "INDEFINITE") {
                this.deletionDateProp = "";
                this.deletionInput = this.$t("admin.processInspector.never");
            } else {
                this.deletionInput = formatDateAndTime("datetime", data.deletionDate, true);
                this.deletionDateProp = data.deletionDate;
            }
        });
    },
    beforeDestroy() {
        this.$root.$off("savedRetention");
        this.$root.$off("savedDeletion");
    },
    methods: {
        ...mapActions("admin", [
            "getProcessInspectorInformation",
            "archiveInstance",
            "searchProcesses",
            "retryProcess",
            "teminateInstance",
            "appImages",
            "getDownloadLog",
            "getViewLogs",
            "getFeatures",
            "eventType",
            "deleteInstanceAction",
            "changeInstanceName"
        ]),
        ...mapActions("version", ["getLatestVersionId"]),
        copyToClipboard,
        convertAndFormatTimeToLocal,
        changeName() {
            if (this.disabledName) {
                this.initialInstanceName = this.processInspectorDescriptionById.instanceName;
            } else {
                this.processInspectorDescriptionById.instanceName = this.initialInstanceName;
                this.wrongPattern = false;
            }
            this.disabledName = !this.disabledName;
            this.$emit("isInstanceNameInEdit", false);
        },
        checkInstanceName() {
            const validatePattern = new RegExp(/^[ a-zA-Z0-9_?!,:;.(){}-]*$/);
            this.wrongPattern = !validatePattern.test(this.processInspectorDescriptionById.instanceName);
            this.$emit("isInstanceNameInEdit", true);
        },
        saveInstanceName() {
            const payload = {
                processInstanceId: this.instanceID,
                newName: this.processInspectorDescriptionById.instanceName
            };
            this.changeInstanceName(payload).then(() => {
                this.disabledName = true;
                this.$toast.showNotify({
                    type: "success",
                    message: this.$t("admin.processInspector.confirmSavedInterface"),
                    timeout: 500
                });
            });
            this.$emit("isInstanceNameInEdit", false);
        },
        downLoadLogs() {
            this.loading = true;
            this.getDownloadLog({
                processInstanceId: this.instanceID,
                processInstanceName: this.getProcessInspectorById.instanceName
            }).then(() => {
                this.loading = false;
                this.eventType({
                    instanceID: this.instanceID,
                    actionType: "DOWNLOAD_LOG"
                });
                this.$emit("actionDone");
            });
        },
        viewLogs() {
            this.titleDialog = this.$t("admin.processInspector.viewLogsConfirm");
            this.messageTitle = this.$t("admin.processInspector.logsMessage");
            this.confirmLabel = this.$t("admin.processInspector.viewLogs");
            this.openDialog = true;
        },
        deleteInstanceModal() {
            this.titleDialog = this.$t("admin.processInspector.appSummary.deleteInstTitle");
            this.messageTitle = this.$t("admin.processInspector.appSummary.deleteInstMess");
            this.deleteInstance = true;
            this.openDialog = true;
        },
        cancelAction() {
            this.messageTitle = "";
            this.deleteInstance = false;
            this.openDialog = false;
        },
        okAction() {
            if (this.titleDialog === this.$t("admin.processInspector.terminateInst")) {
                this.teminateInstance(this.payloadInstace).then(() => {
                    this.$emit("actionDone");
                    this.showNotification();
                    this.$emit("needsRefreshTable");
                    this.$emit("isTerminateDisabled");
                });
            } else if (this.titleDialog === this.$t("admin.processInspector.archiveInst")) {
                this.archiveInstance(this.payloadInstace).then(() => {
                    this.$emit("actionDone");
                    this.showNotification();
                    this.$emit("needsRefreshTable");
                    this.$emit("isAchiveDisabled");
                    this.$emit("closeModal");
                });
            } else if (this.titleDialog === this.$t("admin.processInspector.viewLogsConfirm")) {
                this.getViewLogs(this.instanceID).then(data => {
                    window.open(data.data.url);
                    this.eventType({
                        instanceID: this.instanceID,
                        actionType: "VIEW_LOG"
                    });
                    this.$emit("actionDone");
                });
            } else if (this.titleDialog === this.$t("admin.processInspector.appSummary.deleteInstTitle")) {
                this.getLatestVersionId().then(data => {
                    this.deleteInstanceAction({ versionId: data, processInstanceId: this.instanceID, processDefinitionId: this.processDefId }).then(() => {
                        this.$emit("closeModal");
                        this.$toast.showNotify({
                            type: "success",
                            message: this.$t("admin.processInspector.appSummary.deleteInstanceSuccess"),
                            timeout: 500
                        });
                    });
                })
                    .catch(() => {
                        this.$toast.showNotify({
                            type: "error",
                            message: this.$t("admin.processInspector.appSummary.deleteInstanceError"),
                            timeout: 500
                        });
                    });
                this.deleteInstance = false;
            }
        },
        teminateInstanceModal() {
            this.titleDialog = this.$t("admin.processInspector.terminateInst");
            this.messageTitle = this.$t("admin.processInspector.terminateMessage");
            this.confirmLabel = this.$t("admin.processInspector.terminateConfirm");
            this.openDialog = true;
            this.payloadInstace = {
                processInstanceIds: [this.instanceID]
            };
        },
        retryInstanceModal() {
            const payload = {
                processInstanceIds: [this.instanceID]
            };
            this.retryProcess(payload).then(() => {
                this.$emit("actionDone");
                this.showNotification();
                this.$emit("needsRefreshTable");
                this.$emit("isRetryDisabled");
            });
        },

        archiveInstanceModal() {
            this.titleDialog = this.$t("admin.processInspector.archiveInst");
            this.messageTitle = this.$t("admin.processInspector.archiveMessage");
            this.confirmLabel = this.$t("admin.processInspector.archive");
            this.openDialog = true;
            let numberPerAppObj = {};
            if (Object.keys(this.splitInstancesPerAppObj).length) {
                numberPerAppObj = this.splitInstancesPerAppObj;
            } else {
                numberPerAppObj[this.processDefId] = "1";
            }
            this.payloadInstace = {
                processInstanceIds: [this.instanceID],
                instanceNumberPerApp: numberPerAppObj
            };
        },
        showNotification() {
            this.$toast.showNotify({
                type: "success",
                message: this.$t("admin.processInspector.success"),
                timeout: 500
            });
        }
    }
};
